import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Volume2 } from "lucide-react";
import { NeuSelect } from "../../components/neu/Neu";
import { updateUser } from "../../api/directory";
import { GreetingPreviewButton } from "./GreetingPreviewButton";

// تعديل سريع للجنس من كارت الموظف — يحدّد صوت التحية الصباحية (معاكس للجنس).
export const GenderQuickEdit = ({ userId, personal, onSaved }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(personal?.gender || "");
  const [busy, setBusy] = useState(false);

  const save = async (next) => {
    setValue(next);
    setBusy(true);
    try {
      await updateUser(userId, { personal: { ...(personal || {}), gender: next || null } });
      toast.success(t("personal.genderSaved"));
      onSaved?.();
    } catch {
      toast.error(t("errors.generic"));
      setValue(personal?.gender || "");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="card-gender-edit">
      <p className="text-[11px] tracking-normal text-muted-foreground">{t("personal.gender")}</p>
      <NeuSelect
        className="mt-1"
        data-testid="card-gender-select"
        disabled={busy}
        value={value}
        onChange={(e) => save(e.target.value)}
      >
        <option value="">—</option>
        <option value="male">{t("personal.male")}</option>
        <option value="female">{t("personal.female")}</option>
      </NeuSelect>
      <p className="mt-1 flex items-center gap-1 text-[10px] text-muted-foreground">
        <Volume2 className="h-3 w-3 text-primary" /> {t("personal.genderVoiceHint")}
      </p>
      <GreetingPreviewButton userId={userId} />
    </div>
  );
};
